import { Package } from "lucide-react"
import type { ComponentProps } from "react"
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel"
import type { WooCommerceProduct } from "@/services/woo-commerce-service"
import { filterOutOfStockProducts } from "@/utilities"
import { ProductCard } from "~/components/shared/product-card"

export interface ProductsSliderProps extends ComponentProps<"div"> {
  title: string
  products: WooCommerceProduct[]
}

export const ProductsSlider = ({ title, products }: ProductsSliderProps) => {
  const availableProducts = filterOutOfStockProducts(products)

  const hasProducts = availableProducts && availableProducts.length > 0

  if (!hasProducts)
    return (
      <div className='mt-8 flex flex-col items-center justify-center gap-3 rounded-lg border border-muted-foreground/30 border-dashed bg-muted/30 px-6 py-12 text-center'>
        <Package className='h-10 w-10 text-muted-foreground/60' />
        <div>
          <h3 className='font-medium text-foreground'>
            Nenhum produto disponível
          </h3>
          <p className='mt-1 text-muted-foreground text-sm'>
            Desculpe, não há produtos disponíveis em{" "}
            <span className='font-medium'>{title}</span> no momento.
          </p>
        </div>
      </div>
    )

  return (
    <div className='mt-8'>
      <Carousel
        className='w-full'
        opts={{
          align: "start",
          loop: false,
        }}
      >
        <CarouselContent className='-ml-2 md:-ml-4'>
          {products.map((product) => (
            <CarouselItem
              className='basis-1/2 pl-2 md:basis-1/3 md:pl-4 lg:basis-1/4'
              key={product.id}
            >
              <ProductCard product={product} />
            </CarouselItem>
          ))}
        </CarouselContent>
        <CarouselPrevious className='left-4 size-10 text-primary disabled:text-muted-foreground max-md:hidden 2xl:-left-16' />
        <CarouselNext className='right-4 size-10 text-primary disabled:text-muted-foreground max-md:hidden 2xl:-right-16' />
      </Carousel>
    </div>
  )
}
